import $ from 'jquery'

import colors from '../../../../lib/colors'

import option from '../../edit/option/option'

import { button, input } from '../../../../component/component'

export function getTableDiv(value){

  var div =
    $('<div>')
    .text(value)
    .css({
      padding: '8px'
    })

  return div

}

export function filterMatch(column,filter){

  if(!column.value){
    if(filter === 'null'){
      return true
    } else {
      return false
    }
  }

  if (column.value && filter == '*'){
    return true
  }

  var f = filter.toLowerCase()
  var c = column.value.toLowerCase()

  if(_.includes(c,f)){
    return true
  } else {
    return false
  }

}

export function getFormField(o,p,field){

  var format = function(value){
    return value
  }

  var parse = function(value){
    value = value.trim()
    return value
  }

  var validate = function(value,init){
    if(
      value ||
      field.optional
    ){
      p.change(field,value,true)
      labelDiv.setColor(colors.white)
      return true
    } else {
      p.change(field,value,false)
      labelDiv.setColor(colors.red.s_500)
      return false
    }
  }

  var name = p.model.getName()

  var select = function(){
    option(o,field,name,function(value){
      inputDiv.val(value)
      validate(parse(value))
    })
  }

  var labelDiv =
    button(field.id,null,true)
    .css({
      display: 'block',
      paddingRight: '20px',
    })

  var editDiv =
    button(null,'fi-pencil',false,colors.white)
    .css({
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 0,
      borderTop: `1px solid ${colors.black}`,
      borderBottom: `1px solid ${colors.black}`,
    })
    .click(select)

  var disabled = field.options ? true : false || field.edit ? false : true

  var inputDiv =
    input(disabled)
    .val(
      format(field.value)
    )
    .on('input',function(){
      var value = inputDiv.val()
      validate(parse(value))
    })

  var div =
    $('<div>')
    .css({
      position: 'relative'
    })
    .append(
      labelDiv,
      inputDiv,
    )

  if(field.options && field.edit){
    div.append(editDiv)
  }

  requestAnimationFrame(function(){
    var value = inputDiv.val()
    validate(parse(value))
  })

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/type/text/text.js